export const isPhoneValid = (phone: string): boolean => /^\+\d\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}$/.test(phone);
